import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "How do I receive my business plan after payment?",
    a: "Instantly. The moment your payment is confirmed, you are redirected to a download page and we also email you a secure download link.",
  },
  {
    q: "Can I use this plan to apply for funding?",
    a: "Yes. The plans are formatted to investor and bank-grade standards, including 3-year financial projections, SWOT analysis, and operational sections.",
  },
  {
    q: "Do I get updates or just the PDF?",
    a: "You receive the complete PDF package. Any future updates to a plan you've purchased will be emailed to you free of charge.",
  },
  {
    q: "What currencies and payment methods are supported?",
    a: "We support USD, GBP, and EUR. Payments are processed securely through Stripe (cards) and PayPal.",
  },
  {
    q: "Are purchases final?",
    a: "Yes. Because these are instantly-delivered digital products, all sales are final. We make every detail of each plan explicit on this page so you can buy with complete confidence.",
  },
  {
    q: "Can a single plan support multiple business owners?",
    a: "The plan is licensed for use by the purchasing founder and their team. Reach out if you need a multi-seat licence.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F8FAFC] py-20 sm:py-28">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-12">
          <span className="font-accent text-[#C5A059] text-xs">QUESTIONS</span>
          <h2 className="font-display text-4xl sm:text-5xl text-[#0A192F] mt-4">
            Answers, before you ask.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-white border border-slate-200 px-6"
            >
              <AccordionTrigger className="text-left font-display text-lg text-[#0A192F] hover:text-[#C5A059] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
